import React, { useMemo, useState } from 'react';
import {
    GivelifyLabel,
    DesignTokens,
    GivelifyNotification,
    GivelifyIcon,
} from '@givelify/ui';
import { useMediaQuery, useTheme } from '@mui/material';
import { useAdvancedTranslation } from 'utils/i18n';
import {
    BtnReorder,
    EnvelopesContainer,
    ShowTitle,
} from '../../components/envelopesPageStyle';
import NoItemsPanel from '../../components/NoItemsPanel';
import { useEnvelopesContext } from '../../context/EnvelopesProvider';
import { SortableActiveEnvelopeList } from './SortableActiveEnvelopesList';

const ActiveEnvelopesPage: React.FCC = () => {
    const { at, t } = useAdvancedTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('mobile'));

    const copy = useMemo(
        () => ({
            title: at('pages.settings.envelopes2.active-envelopes-tab.title'),
            pageLoadFail: t('labels.page-load-fail'),
            save: t('labels.save'),
            cancel: t('labels.cancel'),
            showToGiver: t('pages.settings.envelopes2.showToGiver'),
            dragDescription: at('pages.settings.envelopes2.dragDescription'),
            filterBy: t('pages.settings.envelopes2.filterBy'),
            hideToGiver: t('pages.settings.envelopes2.hideToGiver'),
            shown: t('pages.settings.envelopes2.shown'),
            hidden: t('pages.settings.envelopes2.hidden'),
            reorder: t('pages.settings.envelopes2.reorder'),
        }),
        [t, at],
    );

    const { activeEnvelopes, getActiveEnvelopesRequestState } =
        useEnvelopesContext();

    const [openSortModal, setOpenSortModal] = useState<boolean>(false);
    const onOpenSortModal = () => setOpenSortModal(true);
    const onCloseSortModal = () => setOpenSortModal(false);

    return (
        <EnvelopesContainer>
            <ShowTitle>
                <GivelifyLabel
                    id="shownLabel"
                    text={copy.showToGiver}
                    variant="heading3S"
                />
                <BtnReorder
                    id="reorderHandlerMobile"
                    onClick={onOpenSortModal}
                    startIcon={<GivelifyIcon variant="arrange" />}
                    text={copy.reorder}
                    variant="ghost"
                />
            </ShowTitle>
            {isMobile ? null : (
                <GivelifyLabel
                    color={DesignTokens.color.textSecondary}
                    marginBottom={2}
                    text={copy.dragDescription}
                    variant="body1"
                />
            )}

            {getActiveEnvelopesRequestState === 'REQUEST_ERROR' ? (
                <GivelifyNotification
                    open
                    text={copy.pageLoadFail}
                    variant="error"
                />
            ) : activeEnvelopes.length === 0 ? (
                <NoItemsPanel type="shown" />
            ) : (
                <SortableActiveEnvelopeList
                    closeSortModal={onCloseSortModal}
                    isOpenSortModal={openSortModal}
                />
            )}
        </EnvelopesContainer>
    );
};

export default ActiveEnvelopesPage;
